<template lang="pug">
  div
    sidebar
      transition-group.group-list(name="list-complete" mode="out-in" tag="ul")
        li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="license")
          router-link.group-link(:to="{name: 'license'}")
            span {{ $t('subscription') }}
        li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="payments")
          router-link.group-link(:to="{name: 'payment-history'}")
            span {{$t('payment_history')}}
      template(v-if="licenseFlag")
        div.license-desc
          span(v-html="$t('payment_account_info')")
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from "@/components/mixins/sidebar"
import store from "@/api/store"

export default {
  name: "manage-component",
  components: { sidebar: Sidebar },
  methods: {
    getUserData() {
      let stored = store.get("summary")
      this.summary = stored
    },
  },
  watch: {
    $route (to) {
      to.name === 'license' ? this.licenseFlag = true : this.licenseFlag = false
    }
  },
  created() {
    this.getUserData()
    this.licenseFlag = this.$route.name === 'license'
  },
  data() {
    return {
      summary: {},
      licenseFlag: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.license-desc {
  margin-top: 15rem;
  padding: 10px;
  text-align: center;
  line-height: 1.5;
}
</style>
